<template>
  <div>
    <form v-if="!loading && loaded">
      <div class="vx-row mt-4">
        <div class="vx-col sm:w-3/4 w-full">
          <div class="vx-row  mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("PersianName") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input
                class="w-full"
                v-model="actualProductDetails.persianName"
                v-validate="{ required: true }"
                name="persianName"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('persianName')"
                >{{ errors.first("persianName") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("EnglishName") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input
                class="w-full"
                v-model="actualProductDetails.name"
                v-validate="{ required: true }"
                name="englishName"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('englishName')"
                >{{ errors.first("englishName") }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("Description") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <quill-editor
                v-model="actualProductDetails.shortDescription"
                :options="editorOption"
                height="250"
              >
              </quill-editor>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("Review") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <quill-editor
                v-model="actualProductDetails.fullDescription"
                :options="editorOption"
              >
              </quill-editor>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("MetaDescription") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input
                class="w-full"
                v-model="actualProductDetails.metaDescription"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("KeyWords") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input
                class="w-full"
                v-model="actualProductDetails.metaKeywords"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("Pros") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input class="w-full" v-model="actualProductDetails.pros" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <b>{{ $t("Cons") }}</b>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input class="w-full" v-model="actualProductDetails.cons" />
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <div
            class="w-full mb-6"
            v-if="!loading && actualProductDetails.genericProduct"
          >
            <b>{{ $t("GenericProduct") }}</b>
            <div class="w-full">
              <v-select
                label="name"
                name="cat"
                :options="allGenericProducts"
                :reduce="x => x.id"
                :value="
                  allGenericProducts.filter(
                    x => x.id == actualProductDetails.genericProductId
                  )[0].name
                "
                @input="genericChange"
                v-validate="{ required: true }"
                dir="rtl"
              >
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('cat')">{{
                errors.first("cat")
              }}</span>
            </div>
          </div>
          <div class="w-full mb-6">
            <b>{{ $t("Brand") }}</b>
            <div class="w-full">
              <v-select
                label="name"
                name="brand"
                :options="allBrands"
                :reduce="x => x.id"
                :value="
                  allBrands.filter(
                    x => x.id == actualProductDetails.brand.id
                  )[0].name
                "
                @input="brandChange"
                v-validate="{ required: true }"
                dir="rtl"
              >
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('brand')">{{
                errors.first("brand")
              }}</span>
            </div>
          </div>
          <div
            class="w-full mb-6"
            v-if="!loading && actualProductDetails.status"
          >
            <b>{{ $t("Status") }}</b>
            <div class="w-full">
              <v-select
                label="name"
                :options="proStatus"
                :reduce="x => x.id"
                :value="
                  proStatus.filter(x => x.id == actualProductDetails.status)[0]
                    .name
                "
                @input="statusChange"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
          <div class="upload-wrapper">
            <my-upload
              field="img"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              :width="600"
              :height="600"
              langType="fa"
              img-format="jpg"
            ></my-upload>
            <img
              :src="actualProductDetails.coverImage"
              v-if="actualProductDetails.coverImage"
            />
            <img
              :src="
                URLS_CONSTANTS.assets +
                  'Product/' +
                  actualProductDetails.coverUri
              "
              v-if="actualProductDetails.coverUri"
            />
            <button
              v-if="actualProductDetails.coverUri"
              @click.prevent="removeImg"
              class="removeImg"
            >
              <feather-icon icon="XIcon" />
            </button>
          </div>
          <a class="img-box" @click.prevent="toggleShow">
            {{ $t("CoverImage")
            }}<i class="material-icons notranslate">
              cloud_upload
            </i>
          </a>
        </div>
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2 submit-btn bg_l_green"
            @click.prevent="submitForm"
            :disabled="disabled"
            >{{ $t("Submit") }}</vs-button
          >
          <router-link
            :to="{ path: '/ActualProduct/List' }"
            class="vs-component vs-button back-btn"
            color="rgb(62, 201, 214)"
            type="filled"
          >
            {{ $t("BackToList") }}
          </router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapGetters, mapActions } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import myUpload from "vue-image-crop-upload";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    persianName: {
      required: "لطفا نام فارسی را وارد نمایید."
    },
    englishName: {
      required: "لطفا نام انگلیسی را وارد نمایید."
    },
    cat: {
      required: "لطفا دسته‌بندی محصول را انتخاب نمایید."
    },
    brand: {
      required: "لطفا برند محصول را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      actualProductDetails: {},
      show: false,
      proStatus: [
        { name: "پیش نویس", id: 1 },
        { name: "بازبینی", id: 2 },
        { name: "انتشار", id: 3 }
      ],
      editorOption: {
        placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [
              {
                color: [
                  "#000000",
                  "#e60000",
                  "#ff9900",
                  "#ffff00",
                  "#008a00",
                  "#0066cc",
                  "#9933ff",
                  "#ffffff",
                  "#facccc",
                  "#ffebcc",
                  "#ffffcc",
                  "#cce8cc",
                  "#cce0f5",
                  "#ebd6ff",
                  "#bbbbbb",
                  "#f06666",
                  "#ffc266",
                  "#ffff66",
                  "#66b966",
                  "#66a3e0",
                  "#c285ff",
                  "#888888",
                  "#a10000",
                  "#b26b00",
                  "#b2b200",
                  "#006100",
                  "#0047b2",
                  "#6b24b2",
                  "#444444",
                  "#5c0000",
                  "#663d00",
                  "#666600",
                  "#003700",
                  "#002966",
                  "#3d1466",
                  "#007470"
                ]
              }
            ],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"]
          ]
        }
      },
      selectedGenericProduct: "",
      disabled: false,
      loaded: false,
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
  components: {
    "v-select": vSelect,
    quillEditor,
    "my-upload": myUpload
  },
  computed: {
    ...mapGetters({
      actualProduct: "actualProduct/details",
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list",
      loading: "actualProduct/loading"
    })
  },
  mounted() {
    this.fetchBrands();
    this.fetchGenericProducts();
    this.load();
  },
  methods: {
    ...mapActions({
      fetchBrands: "brand/fetchNoSkip",
      fetchGenericProducts: "genericProduct/fetchNoSkip",
      fetchSingle: "actualProduct/fetchSingle",
      updateActualProduct: "actualProduct/update"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.actualProductDetails = Object.assign({}, this.actualProduct);
        this.actualProductDetails.brandId = this.actualProduct.brand.id;
        this.actualProductDetails.genericProductId = this.actualProductDetails.genericProduct.id;
        this.actualProductDetails.parentId = this.actualProductDetails.parent;
        this.actualProductDetails.attributeValues = this.actualProductDetails.genericProduct.attributesGroupQuery;
        setTimeout(() => {
          this.loaded = true;
        }, 0);
      });
    },
    brandChange(brandId) {
      this.actualProductDetails.brandId = brandId;
    },
    genericChange(genericId) {
      this.actualProductDetails.genericProductId = genericId;
    },
    statusChange(id) {
      this.actualProductDetails.status = id;
    },
    removeImg() {
      this.actualProductDetails.coverImage = "";
      this.actualProductDetails.coverUri = "";
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        this.disabled = true;
        if (result) {
          this.updateActualProduct(this.actualProductDetails)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.$router.push("/ActualProduct/List");
              });
            })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          this.disabled = false;
        }
      });
    },
    cropSuccess(imgDataUrl, field) {
      this.actualProductDetails.coverImage = imgDataUrl;
    },
    cropUploadSuccess(jsonData, field) {
      this.$swal({
        position: "center-center",
        type: "warning",
        text: "خطا در بارگذاری تصویر!",
        showConfirmButton: false,
        timer: 2000
      });
    },
    cropUploadFail(status, field) {
      this.$swal({
        position: "center-center",
        type: "warning",
        text: "خطا در تغییر تصویر!",
        showConfirmButton: false,
        timer: 2000
      });
    },
    toggleShow() {
      this.show = !this.show;
    }
  }
};
</script>
